<app-tags-generic
#self
[navigation_param_name]="'news_tag'"
#handlerRouter="routerListenChange"
(changeData)="handlerRouter.performNavigation($event)"
routerListenChange
[routerParamsData]="{'intercept_name': self.navigation_param_name}"

[tags]="tags" (selectionChange)="selectChange($event)"></app-tags-generic>
